import { curveMonotoneX, line as lineShape } from 'd3-shape'
import { motion } from 'framer-motion'
import React, { Fragment, Key } from 'react'

import { LineChartDataPoint } from 'components/reports/report-utils'

const Line: React.FC<{
  color: string
  xScale(...args): number
  yScale(...args): number
  yMax: number
  dataPoint: LineChartDataPoint
  clearTargetTooltip?: () => void
  setTargetTooltip?: () => void
  data: LineChartDataPoint[]
  x: string
  y: string
}> = ({ color, xScale, yScale, yMax, dataPoint, data, x, y }) => {
  const drawLine = lineShape()
    .x((d) => xScale(d[x]))
    .y((d) => yScale(d[y]))
    .curve(curveMonotoneX)

  const maskId = `mask-${dataPoint[x]}`
  const duration = data.length - 1

  return (
    <>
      <mask id={maskId}>
        <motion.rect
          fill="white"
          height={yMax}
          initial={{
            width: 0
          }}
          transition={{
            type: 'easeIn',
            delay: 0.25,
            duration: duration
          }}
        />
      </mask>
      <g mask={`url(#${maskId})`}>
        {/* @ts-ignore TODO: Figure out why TS does not like this */}
        <path d={drawLine(data)} fill="none" stroke={color} strokeWidth={2} />
        {data.map((d) => {
          const xValue = xScale(d[x])
          const yValue = yScale(d[y])

          return (
            <Fragment key={d[x] as Key}>
              <circle
                css={{
                  fillOpacity: 'var(--circle-opacity)'
                }}
                cx={xValue}
                cy={yValue}
                fill={color}
                r={3}
              />
              <circle
                css={{ cursor: 'crosshair' }}
                cx={xValue}
                cy={yValue}
                fill="transparent"
                r={8}
              />
            </Fragment>
          )
        })}
      </g>
    </>
  )
}

Line.displayName = 'Line'

export default React.memo(Line)
